export default "__VITE_ASSET__Cd46A6df__"